import {FormModel} from '../../../form/form/api/entity/form.model';
import {WithSummaryModel} from '../../../common/entity/dto/plain/withSummary.model';
import {ExamFormSummaryModel} from './examFormSummary.model';
import {ConsultationSummaryModel} from '../../../medical/consultation/consultation/api/model/consultationSummary.model';

export class ExamFormModel extends WithSummaryModel<ExamFormSummaryModel> {
    form: FormModel;
    consultation: ConsultationSummaryModel;
}
